const criarChave = (chave, valor = true) => ({ chave, valor })

export default {
	REDIRECIONAMENTO_DESABILITADO: criarChave('isRedirecionamentoDesabilitado'),
	RESPOSTA_ARRAY_BUFFER: criarChave('responseType', 'arraybuffer'),
}
